import React from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../services/authService';
import { can, canAny, isAdmin } from '../utils/permission';

function ProtectedRoute({ children, permission, anyOf, adminOnly }) {
  if (!authService.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !isAdmin()) {
    return <Navigate to="/dashboard" replace />;
  }

  if (anyOf && !canAny(...anyOf)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (permission && !can(permission)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default ProtectedRoute;